<template>
	<div style="width: 100%;">
		<div
			style="width: 210px;padding-top: 9px;padding-bottom: 9px;font-size: 14px;margin: auto;text-align: center;background-color: #aaa7a7;border-radius: 10px 10px 0px 0px;border-bottom: solid 1px #c6c6c6;">
			{{selectdItem.compontChildren[0].name + '设置'}}
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">轮播数据</div>
		</div>
		<div style="padding-bottom: 10px;border-bottom: solid 1px #e8e8e8 ;"
			v-for="(item,index) in selectdItem.compontChildren[0].data.list" :key="index">
			<!-- 修改图片具体地址 -->
			<div
				style="margin-left: 10px;padding-top: 10px;display: flex;justify-content: space-between;align-items: center;">
				<div>
					位置 {{index + 1}}
				</div>
				<div style="width: 100px;margin-right: 10px;">
					<el-select @change="item.url = '';item.data = {}" size="mini" v-model="item.type" placeholder="请选择">
						<el-option label="图片" value="img">
						</el-option>
						<el-option label="视频" value="video">
						</el-option>
					</el-select>
				</div>
			</div>
			<div style="display: flex;justify-content: center;">
				<!-- 背景图片 -->
				<div style="display: flex;align-items: center;height: 72px;width: 210px;justify-content: space-around;">
					<div @click="dialogVisibleImgs = true;setIndex = index"
						style="height: 60px;width: 120px;background-color: #fff;display: flex;align-items: center;justify-content: center;cursor: pointer;">
						<el-image v-if="item.url == ''" :src="item.url"
							style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
							<div slot="error" class="image-slot">
								<i style="font-weight: bold;font-size: 22px;" class="el-icon-plus"></i>
							</div>
						</el-image>

						<el-image v-if="getFileType(item.data.name) == 'image' && item.url != ''" :src="item.url"
							style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
							<div slot="error" class="image-slot">
								<i style="font-weight: bold;font-size: 22px;" class="el-icon-plus"></i>
							</div>
						</el-image>

						<video v-if="getFileType(item.data.name) != 'image' && item.url != ''"
							style="width: 100%;height: 100%;object-fit: cover;">
							<source :src="item.url" type="video/webm">
						</video>

					</div>
					<div @click="deleteItem(index);"
						v-if="index != 0 && index != selectdItem.compontChildren[0].data.list.length - 1"
						style="color: #8c62ff;cursor: pointer;font-weight: bold;">删除
					</div>
				</div>
			</div>
			<div v-if="item.type == 'video'"
				style="margin-left: 10px;padding-top: 10px;display: flex;justify-content: space-between;align-items: center;">
				<div>
					自动播放
				</div>
				<div style="width: 100px;margin-right: 10px;">
					<el-select size="mini" v-model="item.isAuto" placeholder="请选择">
						<el-option label="是" :value="true">
						</el-option>
						<el-option label="否" :value="false">
						</el-option>
					</el-select>
				</div>
			</div>
			<div v-if="item.type == 'video'"
				style="margin-left: 10px;padding-top: 10px;display: flex;justify-content: space-between;align-items: center;">
				<div>
					循环播放
				</div>
				<div style="width: 100px;margin-right: 10px;">
					<el-select size="mini" v-model="item.loop" placeholder="请选择">
						<el-option label="是" :value="true">
						</el-option>
						<el-option label="否" :value="false">
						</el-option>
					</el-select>
				</div>
			</div>
			<div v-if="item.type == 'video'"
				style="margin-left: 10px;padding-top: 10px;display: flex;justify-content: space-between;align-items: center;">
				<div>
					显示控制器
				</div>
				<div style="width: 100px;margin-right: 10px;">
					<el-select size="mini" v-model="item.control" placeholder="请选择">
						<el-option label="是" :value="true">
						</el-option>
						<el-option label="否" :value="false">
						</el-option>
					</el-select>
				</div>
			</div>

			<select-page style="margin-top: 10px;" :link="item.link"
				@confirmSelect="($event)=>{item.link = $event}"></select-page>
			<div>
				<div v-for="(levelItem,levelIndex) in item.levelList" :key="levelIndex">
					<div style="margin: 10px;color: #ff8010;display: flex;justify-content: space-between;">
						<div>
							位置 {{index + 1}} - 图层 {{ levelIndex + 1 }}
						</div>
						<div style="cursor: pointer;color: #8c62ff;" @click="item.levelList.splice(levelIndex,1)">
							删除
						</div>
					</div>
					<select-page style="margin-top: 10px;" :link="levelItem.link"
						@confirmSelect="($event)=>{levelItem.link = $event}"></select-page>
					<!-- <video v-if="getFileType(levelItem.data.name) != 'image' && levelItem.url != ''"
						style="width: 100%;height: 100%;object-fit: cover;">
						<source :src="levelItem.url" type="video/webm">
					</video> -->
					<div style="margin: 10px;display: flex;align-items: center;">
						<div style="width: 100px">
							图层类型
						</div>
						<el-select @change="levelItem.url = '';levelItem.data = {}" style="margin-left: 10px;"
							size="mini" v-model="levelItem.type" placeholder="请选择">
							<el-option v-for="(levelOptionItem,levelOptionIndex) in levelOptions"
								:key="levelOptionIndex" :label="levelOptionItem.label" :value="levelOptionItem.value">
							</el-option>
						</el-select>
					</div>

					<div @click="dialogVisibleLevleImgs = true;levelSelceItem = levelItem"
						v-if="levelItem.type == 'img' || levelItem.type == 'video'"
						style="height: 60px;width: 120px;background-color: #fff;display: flex;align-items: center;justify-content: center;cursor: pointer;margin: auto;">
						<el-image v-if="levelItem.url == '' && (levelItem.type == 'img' || levelItem.type == 'video')"
							:src="levelItem.url"
							style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
							<div slot="error" class="image-slot">
								<i style="font-weight: bold;font-size: 22px;" class="el-icon-plus"></i>
							</div>
						</el-image>

						<el-image v-if="levelItem.type == 'img' && levelItem.url != ''" :src="levelItem.url"
							style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
							<div slot="error" class="image-slot">
								<i style="font-weight: bold;font-size: 22px;" class="el-icon-plus"></i>
							</div>
						</el-image>

						<video v-if="levelItem.type == 'video' && levelItem.url != ''"
							style="width: 100%;height: 100%;object-fit: cover;">
							<source :src="levelItem.url" type="video/webm">
						</video>

					</div>

					<div v-if="levelItem.type == 'video'"
						style="margin-left: 10px;padding-top: 10px;display: flex;justify-content: space-between;align-items: center;">
						<div>
							自动播放
						</div>
						<div style="width: 100px;margin-right: 10px;">
							<el-select size="mini" v-model="levelItem.isAuto" placeholder="请选择">
								<el-option label="是" :value="true">
								</el-option>
								<el-option label="否" :value="false">
								</el-option>
							</el-select>
						</div>
					</div>
					<div v-if="item.type == 'video'"
						style="margin-left: 10px;padding-top: 10px;display: flex;justify-content: space-between;align-items: center;">
						<div>
							循环播放
						</div>
						<div style="width: 100px;margin-right: 10px;">
							<el-select size="mini" v-model="levelItem.loop" placeholder="请选择">
								<el-option label="是" :value="true">
								</el-option>
								<el-option label="否" :value="false">
								</el-option>
							</el-select>
						</div>
					</div>
					<div v-if="levelItem.type == 'video'"
						style="margin-left: 10px;padding-top: 10px;display: flex;justify-content: space-between;align-items: center;">
						<div>
							显示控制器
						</div>
						<div style="width: 100px;margin-right: 10px;">
							<el-select size="mini" v-model="levelItem.control" placeholder="请选择">
								<el-option label="是" :value="true">
								</el-option>
								<el-option label="否" :value="false">
								</el-option>
							</el-select>
						</div>
					</div>

					<div v-if="levelItem.type == 'img'"
						style="display: flex;align-items: center;justify-content: space-between;padding: 6px;">
						<div>显示模式</div>
						<div style="display: flex;align-items: center;margin-left:8px;">
							<div @click="levelItem.mode = 'cover'"
								:style="{backgroundColor:levelItem.mode == 'cover'?'#8c62ff':'#fff',color:levelItem.mode == 'cover'?'#fff':'#000',border:levelItem.mode == 'cover'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 56px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">裁剪填充</span>
							</div>
							<div @click="levelItem.mode = 'contain'"
								:style="{backgroundColor:levelItem.mode == 'contain'?'#8c62ff':'#fff',color:levelItem.mode == 'contain'?'#fff':'#000',border:levelItem.mode == 'contain'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 56px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">原图填充</span>
							</div>
						</div>
					</div>

					<div class="item" v-if="levelItem.type == 'img' || levelItem.type == 'video'">
						<div>{{levelItem.type == 'img'?'图片':'视频'}}宽度</div>
						<div>
							<wm-input-number :value="equipment == 'pc'?levelItem.width : levelItem.phoneWidth"
								:disabled="false" style="border: solid 1px #959595 ;"
								:styleObj="{width: '50px',height: '22px'}" :step="1" :min="1"
								:max="100000000000000000000"
								@change="(e)=>{equipment == 'pc'?levelItem.width = e : levelItem.phoneWidth = e}"></wm-input-number>
						</div>
					</div>
					<div class="item" v-if="levelItem.type == 'img' || levelItem.type == 'video'">
						<div>{{levelItem.type == 'img'?'图片':'视频'}}高度</div>
						<div>
							<wm-input-number :value="equipment == 'pc'?levelItem.height : levelItem.phoneHeight "
								:disabled="false" style="border: solid 1px #959595 ;"
								:styleObj="{width: '50px',height: '22px'}" :step="1" :min="1"
								:max="100000000000000000000"
								@change="(e)=>{equipment == 'pc'? levelItem.height = e : levelItem.phoneHeight = e}"></wm-input-number>
						</div>
					</div>



					<div style="margin: 10px;display: flex;align-items: center;">
						<div style="width: 100px">
							图层等级
						</div>
						<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
							:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
							:value="levelItem.zIndex" @change="(e)=>{levelItem.zIndex = e}"></wm-input-number>
					</div>
					<div
						style="transform: scale(0.85);color: #aaa7a7;font-size: 12px;width: 100%;text-align: center;margin-bottom: 10px;">
						图层等级越大越置顶</div>

					<div style="margin: 10px;display: flex;align-items: center;">
						<set-animate :animateConfig="levelItem.animateConfig"></set-animate>
					</div>

					<div style="margin-left: 10px;" v-if="levelItem.type == 'text' || levelItem.type == 'btn'">
						<div>{{levelItem.type == 'text'?'文字内容':'按钮名称'}}</div>
					</div>


					<div style="margin-left: 10px;margin-top: 10px;margin-right: 10px;"
						v-if="levelItem.type == 'text' || levelItem.type == 'btn'">
						<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="levelItem.tit">
						</el-input>
					</div>



					<div style="" class="flex-item-center"
						style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
						<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
							<div @click="levelItem.position = 'center'"
								:style="{backgroundColor: levelItem.position == 'center'?'#8c62ff':'#fff',color: levelItem.position == 'center'?'#fff':'#000',border: levelItem.position == 'center'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 36px;text-align: center;">
								<span style="scale: 0.85;">中</span>
							</div>
							<div @click="levelItem.position  = 'top'"
								:style="{backgroundColor:levelItem.position  == 'top'?'#8c62ff':'#fff',color: levelItem.position  == 'top'?'#fff':'#000',border: levelItem.position  == 'top'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 36px;text-align: center;">
								<span style="scale: 0.85;">上</span>
							</div>
							<div @click="levelItem.position = 'bottom'"
								:style="{backgroundColor:levelItem.position == 'bottom'?'#8c62ff':'#fff',color:levelItem.position == 'bottom'?'#fff':'#000',border:levelItem.position == 'bottom'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 36px;text-align: center;">
								<span style="scale: 0.85;">下</span>
							</div>
							<div @click="levelItem.position = 'left'"
								:style="{backgroundColor: levelItem.position == 'left'?'#8c62ff':'#fff',color: levelItem.position == 'left'?'#fff':'#000',border: levelItem.position == 'left'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 36px;text-align: center;">
								<span style="scale: 0.85;">左</span>
							</div>
							<div @click="levelItem.position = 'right'"
								:style="{backgroundColor:levelItem.position == 'right'?'#8c62ff':'#fff',color:levelItem.position == 'right'?'#fff':'#000',border:levelItem.position == 'right'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 36px;text-align: center;">
								<span style="scale: 0.85;">右</span>
							</div>
						</div>
					</div>

					<div v-if="levelItem.type == 'text' || levelItem.type == 'btn'"
						style="margin: 10px;display: flex;align-items: center;justify-content: space-between;">
						<el-select size="mini" style="width: 100px;" v-model="levelItem.titFamily" placeholder="选择字体">
							<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
								:value="fontItem.name">
							</el-option>
						</el-select>
						<el-color-picker size="mini" v-model="levelItem.titColor"
							style="margin-left: 3px;"></el-color-picker>
						<div
							style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
							<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
								:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
								:value="levelItem.titSize" @change="(e)=>{levelItem.titSize = e}"></wm-input-number>
						</div>
					</div>
					<div v-if="levelItem.type == 'text' || levelItem.type == 'btn'"
						style="margin: 10px;display: flex;justify-content: space-between;">
						<div>悬停字体颜色</div>
						<el-color-picker size="mini" v-model="levelItem.titHoverColor"
							style="margin-left: 3px;"></el-color-picker>
					</div>


					<div v-if="levelItem.type == 'btn'"
						style="margin: 10px;display: flex;justify-content: space-between;">
						<div>悬停边框颜色</div>
						<el-color-picker size="mini" v-model="levelItem.btnBorderHoverColor"
							style="margin-left: 3px;"></el-color-picker>
					</div>

					<div v-if="levelItem.type == 'btn'"
						style="margin: 10px;display: flex;justify-content: space-between;">
						<div>悬停背景颜色</div>
						<el-color-picker size="mini" v-model="levelItem.btnHoverColor"
							style="margin-left: 3px;"></el-color-picker>
					</div>

					<div v-if="levelItem.type == 'btn'"
						style="margin: 10px;display: flex;justify-content: space-between;">
						<div>点击字体颜色</div>
						<el-color-picker size="mini" v-model="levelItem.titClickColor"
							style="margin-left: 3px;"></el-color-picker>
					</div>

					<div v-if="levelItem.type == 'btn'"
						style="margin: 10px;display: flex;justify-content: space-between;">
						<div>点击边框颜色</div>
						<el-color-picker size="mini" v-model="levelItem.btnBorderClickColor"
							style="margin-left: 3px;"></el-color-picker>
					</div>

					<div v-if="levelItem.type == 'btn'"
						style="margin: 10px;display: flex;justify-content: space-between;">
						<div>点击背景颜色</div>
						<el-color-picker size="mini" v-model="levelItem.btnClickColor"
							style="margin-left: 3px;"></el-color-picker>
					</div>

					<div style="" class="flex-item-center"
						style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
						<div style="margin-top: 10px;">
							<div>内边距</div>
							<div
								style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="paddingLevelSet($event,levelItem)" v-model="levelItem.padding[0]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;">顶部</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="paddingLevelSet($event,levelItem)" v-model="levelItem.padding[1]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;">左侧</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="paddingLevelSet($event,levelItem)" v-model="levelItem.padding[2]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;">底部</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="paddingLevelSet($event,levelItem)" v-model="levelItem.padding[3]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;">右侧</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
									<i @click="levelItem.paddingLeveAll = !levelItem.paddingLeveAll"
										:style="{color:levelItem.paddingLeveAll?'#8c62ff':'#000'}"
										style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
										class="el-icon-paperclip tit-icon"></i>
								</div>
							</div>
						</div>
					</div>


					<div style="" class="flex-item-center"
						style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
						<div style="margin-top: 10px;">
							<div>外边距</div>
							<div
								style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="marginLevelSet($event,levelItem)" v-model="levelItem.margin[0]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;">顶部</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="marginLevelSet($event,levelItem)" v-model="levelItem.margin[1]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;">左侧</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="marginLevelSet($event,levelItem)" v-model="levelItem.margin[2]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;">底部</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="marginLevelSet($event,levelItem)" v-model="levelItem.margin[3]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;">右侧</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
									<i @click="levelItem.marginLevelAll = !levelItem.marginLevelAll"
										:style="{color:levelItem.marginLevelAll?'#8c62ff':'#000'}"
										style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
										class="el-icon-paperclip tit-icon"></i>
								</div>
							</div>
						</div>
					</div>


					<div style="" class="flex-item-center"
						style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
						<div style="font-size: 12px;">组件边框</div>
						<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
							<div @click="levelItem.border.type = ''"
								:style="{backgroundColor: levelItem.border.type == ''?'#8c62ff':'#fff',color: levelItem.border.type == ''?'#fff':'#000',border: levelItem.border.type == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 36px;text-align: center;">
								<span style="scale: 0.85;">无</span>
							</div>
							<div @click="levelItem.border.type = 'solid'"
								:style="{backgroundColor: levelItem.border.type == 'solid'?'#8c62ff':'#fff',color: levelItem.border.type == 'solid'?'#fff':'#000',border: levelItem.border.type == 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 36px;text-align: center;">
								<span style="scale: 0.85;">实线</span>
							</div>
							<div @click="levelItem.border.type = 'dashed'"
								:style="{backgroundColor:levelItem.border.type == 'dashed'?'#8c62ff':'#fff',color:levelItem.border.type == 'dashed'?'#fff':'#000',border:levelItem.border.type == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 36px;text-align: center;">
								<span style="scale: 0.85;">虚线</span>
							</div>
						</div>
					</div>
					<div style="" class="flex-item-center"
						style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
						<div style="font-size: 12px;">边框颜色</div>
						<el-color-picker size="mini" style="height: 34px;width: 34px;"
							v-model="levelItem.border.color"></el-color-picker>
						<el-input size="mini" style="height: 34px;width: 82px;" disabled
							:value="levelItem.border.color"></el-input>
					</div>
					<div style="" class="flex-item-center"
						style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
						<div v-if="levelItem.border.borderSize" style="margin-top: 10px;">
							<div>线条大小</div>
							<div
								style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="levelChangeContainerSize($event,levelItem)"
										v-model="levelItem.border.borderSize[0]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;">顶部</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="levelChangeContainerSize($event,levelItem)"
										v-model="levelItem.border.borderSize[1]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;">左侧</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="levelChangeContainerSize($event,levelItem)"
										v-model="levelItem.border.borderSize[2]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;">底部</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="levelChangeContainerSize($event,levelItem)"
										v-model="levelItem.border.borderSize[3]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;">右侧</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
									<i @click="levelItem.borderContainerSizeAll = !levelItem.borderContainerSizeAll"
										:style="{color:levelItem.borderContainerSizeAll?'#8c62ff':'#000'}"
										style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
										class="el-icon-paperclip tit-icon"></i>
								</div>
							</div>
						</div>
					</div>

					<div style="" class="flex-item-center"
						style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
						<div style="margin-top: 10px;" v-if="levelItem.border.borderRadius">
							<div>边框圆角</div>
							<div
								style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px 0px 6px 6px;">
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="levelChangeContainerBorderRadius($event,levelItem)"
										v-model="levelItem.border.borderRadius[0]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;">顶部</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="levelChangeContainerBorderRadius($event,levelItem)"
										v-model="levelItem.border.borderRadius[1]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;">左侧</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="levelChangeContainerBorderRadius($event,levelItem)"
										v-model="levelItem.border.borderRadius[2]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top:2px;">底部</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="levelChangeContainerBorderRadius($event,levelItem)"
										v-model="levelItem.border.borderRadius[3]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;">右侧</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
									<i @click="levelItem.borderContainerRadiusAll = !levelItem.borderContainerRadiusAll"
										:style="{color:levelItem.borderContainerRadiusAll?'#8c62ff':'#000'}"
										style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
										class="el-icon-paperclip tit-icon"></i>
								</div>
							</div>
						</div>
					</div>


					<div style="" class="flex-item-center"
						style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
						<div style="display: flex;justify-content: center;cursor: pointer;margin-top: 15px;">
							<div style="background-color: #F6F7F9;display: flex;flex-direction: column;width: 198px;">
								<div style="display: flex;justify-content: space-between">
									<div style="margin: 6px;">
										容器背景
									</div>
									<div v-if="levelItem.bg.bgtype"
										style="display: flex;align-items: center;margin-left:0px;">
										<div @click="levelItem.bg.bgtype = 'color'"
											:style="{backgroundColor:levelItem.bg.bgtype == 'color'?'#8c62ff':'#fff',color:levelItem.bg.bgtype == 'color'?'#fff':'#000',border:levelItem.bg.bgtype == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
											style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
											<span style="scale: 0.85;">纯色</span>
										</div>
										<div @click="levelItem.bg.bgtype = 'gradient'"
											:style="{backgroundColor:levelItem.bg.bgtype == 'gradient'?'#8c62ff':'#fff',color:levelItem.bg.bgtype == 'gradient'?'#fff':'#000',border:levelItem.bg.bgtype == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
											style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
											<span style="scale: 0.85;">渐变</span>
										</div>
										<div @click="levelItem.bg.bgtype = 'img'"
											:style="{backgroundColor:levelItem.bg.bgtype == 'img'?'#8c62ff':'#fff',color:levelItem.bg.bgtype == 'img'?'#fff':'#000',border:levelItem.bg.bgtype == 'img'?'solid 1px #8c62ff':'solid 1px #959595' }"
											style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
											<span style="scale: 0.85;">图片</span>
										</div>
									</div>
								</div>
								<div v-if="levelItem.bg.bgtype == 'img'"
									style="display: flex;justify-content: center;margin-top: 10px;width: 235px;font-size: 12px;">
									<div
										style="display: flex;align-items: center;background-color: #F6F7F9;height: 38px;width: 210px;justify-content: space-around;">
										<div style="font-size: 12px;">
											背景图片
										</div>
										<div @click="dialogVisible = true"
											style="height: 30px;width: 30px;background-color: #fff;display: flex;align-items: center;justify-content: center;">
											<el-image :src="levelItem.bg.img" style="cursor: pointer;">
												<div slot="error" class="image-slot">
													<i style="font-size: 16px;" class="el-icon-plus"></i>
												</div>
											</el-image>
										</div>
										<el-select size="mini" style="width: 82px;" v-model="levelItem.bg.type"
											filterable allow-create default-first-option placeholder="渲染方式">
											<el-option label="重复" value="repeat">
											</el-option>
											<el-option label="x轴重复" value="repeat-x">
											</el-option>
											<el-option label="y轴重复" value="repeat-y">
											</el-option>
											<el-option label="平铺" value="">
											</el-option>
											<el-option label="不平铺" value="no-repeat">
											</el-option>
										</el-select>
									</div>
								</div>

								<div v-if="levelItem.bg.bgtype == 'img'" style="display: flex;justify-content: center;">
									<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
										<div style="width: 40px;">
											宽度:
										</div>
										<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
											:styleObj="{width: '100px',height: '30px'}" :step="1" :min="1"
											:max="10000000000" :value="levelItem.bg.bgImgWidth"
											@change="(e)=>{levelItem.bg.bgImgWidth = e}"></wm-input-number>
									</div>
								</div>
								<div v-if="levelItem.bg.bgtype == 'img'" style="display: flex;justify-content: center;">
									<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
										<div style="width: 40px;">
											高度:
										</div>
										<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
											:styleObj="{width: '100px',height: '30px'}" :step="1" :min="1"
											:max="10000000000" :value="levelItem.bg.bgImgHeigth"
											@change="(e)=>{levelItem.bg.bgImgHeigth = e}"></wm-input-number>
									</div>
								</div>

								<div v-if="levelItem.bg.bgtype == 'img'"
									style="display: flex;align-items: center;margin-left: 10px;margin-top: 10px;">
									<div>
										背景位置
									</div>

									<el-select @change="(e)=>{levelItem.bg.position = e}"
										style="margin-left: 10px;width: 120px;" v-model="levelItem.bg.position"
										filterable allow-create default-first-option placeholder="图片位置">
										<el-option label="左上方" value="top left">
										</el-option>
										<el-option label="上中间" value="top center">
										</el-option>
										<el-option label="右上方" value="top right">
										</el-option>
										<el-option label="左中方" value="center left">
										</el-option>
										<el-option label="居中" value="center center">
										</el-option>
										<el-option label="右中方" value="center right">
										</el-option>
										<el-option label="下左方" value="bottom left">
										</el-option>
										<el-option label="下居中" value="bottom center">
										</el-option>
										<el-option label="下右方" value="bottom right">
										</el-option>
									</el-select>
								</div>

								<div v-if="levelItem.bg.bgtype == 'gradient'"
									style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
									<div
										style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
										<div style="display: flex;flex-direction: column;">
											<div style="display: flex;align-items: center;">
											</div>
											<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
												placeholder="请输入内容" v-model="levelItem.bg.bgGradient">
											</el-input>
										</div>
										<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
											需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
												href="https://www.eggradients.com/">Gradient1</a> <a
												style="margin-left: 4px;" target="_blank"
												href="https://webgradients.com/">Gradient2</a>
										</div>
									</div>
								</div>
								<div v-if="levelItem.bg.bgtype && levelItem.bg.bgtype == 'color'"
									style="display: flex;justify-content: center;margin-top: 10px;width: 210px;margin-bottom: 20px;font-size: 12px;">
									<div
										style="display: flex;align-items: center;background-color: #F6F7F9;height: 34px;width: 210px;justify-content: space-around;">
										<div style="font-size: 12px;">
											背景纯色
										</div>
										<el-color-picker size="mini" @change="(e)=>{
											levelItem.bg.color = e
										}" style="height: 28px;width: 28px;margin-top: 4px;" v-model="levelItem.bg.color"></el-color-picker>
									</div>
								</div>
							</div>
						</div>
					</div>




				</div>
			</div>





			<div @click="addLevel(item)" v-if="item.url != ''"
				style="padding: 6px 8px;background-color: #000000 ;color: #fff;border-radius: 10px;width: fit-content;margin: auto;margin-top: 10px;cursor: pointer;">
				添加图层</div>

			<div v-if="item.type == 'video'"
				style="margin-left: 10px;padding-top: 10px;display: flex;justify-content: space-between;align-items: center;">
				<!-- <div>
					视频封面
				</div> -->
				<!-- 	<div style="width: 120px;">
					<el-select size="mini" v-model="item.control" placeholder="请选择">
						<el-option label="是" :value="true">
						</el-option>
						<el-option label="否" :value="false">
						</el-option>
					</el-select>
				</div> -->
			</div>
		</div>
		<!-- <div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 20px;">
			<div style="font-size: 12px;">轮播宽度</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div>
					<wm-input-number :iptWidth="60" :disabled="false" :styleObj="{width: '120px',height: '32px'}"
						:step="1" :min="1" :max="10000000" :value="selectdItem.preStyle.selfStyle.width"
						@change="(e)=>{selectdItem.preStyle.selfStyle.width = e}"></wm-input-number>
				</div>
			</div>
		</div> -->
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">轮播高度</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div>
					<wm-input-number :iptWidth="60" :disabled="false" :styleObj="{width: '120px',height: '32px'}"
						:step="1" :min="1" :max="10000000"
						:value="equipment=='pc'?selectdItem.preStyle.selfStyle.height:selectdItem.preStyle.selfStyle.phoneHeight"
						@change="(e)=>{equipment=='pc'?selectdItem.preStyle.selfStyle.height = e : selectdItem.preStyle.selfStyle.phoneHeight=e }"></wm-input-number>
				</div>
			</div>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 20px;">
			<div style="font-size: 12px;">动效类型</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div style="width: 100px;">
					<el-select size="mini" v-model="selectdItem.preStyle.selfStyle.type" placeholder="请选择">
						<el-option v-for="(item,index) in types" :key="index" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">自动播放</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.preStyle.selfStyle.isAuto = !selectdItem.preStyle.selfStyle.isAuto"
					:style="{backgroundColor: selectdItem.preStyle.selfStyle.isAuto?'#8c62ff':'#fff',color: selectdItem.preStyle.selfStyle.isAuto?'#fff':'#000',border: selectdItem.preStyle.selfStyle.isAuto?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.preStyle.selfStyle.isAuto = !selectdItem.preStyle.selfStyle.isAuto"
					:style="{backgroundColor: !selectdItem.preStyle.selfStyle.isAuto?'#8c62ff':'#fff',color: !selectdItem.preStyle.selfStyle.isAuto?'#fff':'#000',border: !selectdItem.preStyle.selfStyle.isAuto?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">显示指示器</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.preStyle.selfStyle.isNeedArrow = !selectdItem.preStyle.selfStyle.isNeedArrow"
					:style="{backgroundColor: selectdItem.preStyle.selfStyle.isNeedArrow?'#8c62ff':'#fff',color: selectdItem.preStyle.selfStyle.isNeedArrow?'#fff':'#000',border: selectdItem.preStyle.selfStyle.isNeedArrow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.preStyle.selfStyle.isNeedArrow = !selectdItem.preStyle.selfStyle.isNeedArrow"
					:style="{backgroundColor: !selectdItem.preStyle.selfStyle.isNeedArrow?'#8c62ff':'#fff',color: !selectdItem.preStyle.selfStyle.isNeedArrow?'#fff':'#000',border: !selectdItem.preStyle.selfStyle.isNeedArrow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">显示分页按钮</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.preStyle.selfStyle.isNeedIndicator = !selectdItem.preStyle.selfStyle.isNeedIndicator"
					:style="{backgroundColor: selectdItem.preStyle.selfStyle.isNeedIndicator?'#8c62ff':'#fff',color: selectdItem.preStyle.selfStyle.isNeedIndicator?'#fff':'#000',border: selectdItem.preStyle.selfStyle.isNeedIndicator?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.preStyle.selfStyle.isNeedIndicator = !selectdItem.preStyle.selfStyle.isNeedIndicator"
					:style="{backgroundColor: !selectdItem.preStyle.selfStyle.isNeedIndicator?'#8c62ff':'#fff',color: !selectdItem.preStyle.selfStyle.isNeedIndicator?'#fff':'#000',border: !selectdItem.preStyle.selfStyle.isNeedIndicator?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">指示器颜色</div>
			<el-color-picker size="mini" style="height: 34px;width: 34px;"
				v-model="selectdItem.preStyle.selfStyle.indicatorColor"></el-color-picker>
			<el-input size="mini" style="height: 34px;width: 72px;" disabled
				:value="selectdItem.preStyle.selfStyle.indicatorColor"></el-input>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">分页按钮颜色</div>
			<el-color-picker size="mini" style="height: 34px;width: 34px;"
				v-model="selectdItem.preStyle.selfStyle.navBtnColor"></el-color-picker>
			<el-input size="mini" style="height: 34px;width: 72px;" disabled
				:value="selectdItem.preStyle.selfStyle.navBtnColor"></el-input>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">分页按钮大小</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div>
					<wm-input-number :iptWidth="60" :disabled="false" :styleObj="{width: '100px',height: '32px'}"
						:step="1" :min="1" :max="10000000" :value="selectdItem.preStyle.selfStyle.navBtnSize"
						@change="(e)=>{selectdItem.preStyle.selfStyle.navBtnSize = e}"></wm-input-number>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">循环播放</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.preStyle.selfStyle.isLoop = !selectdItem.preStyle.selfStyle.isLoop"
					:style="{backgroundColor: selectdItem.preStyle.selfStyle.isLoop?'#8c62ff':'#fff',color: selectdItem.preStyle.selfStyle.isLoop?'#fff':'#000',border: selectdItem.preStyle.selfStyle.isLoop?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.preStyle.selfStyle.isLoop = !selectdItem.preStyle.selfStyle.isLoop"
					:style="{backgroundColor: !selectdItem.preStyle.selfStyle.isLoop?'#8c62ff':'#fff',color: !selectdItem.preStyle.selfStyle.isLoop?'#fff':'#000',border: !selectdItem.preStyle.selfStyle.isLoop?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">组件边框</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.preStyle.selfStyle.border.type = ''"
					:style="{backgroundColor: selectdItem.preStyle.selfStyle.border.type == ''?'#8c62ff':'#fff',color: selectdItem.preStyle.selfStyle.border.type == ''?'#fff':'#000',border: selectdItem.preStyle.selfStyle.border.type == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">无</span>
				</div>
				<div @click="selectdItem.preStyle.selfStyle.border.type = 'solid'"
					:style="{backgroundColor: selectdItem.preStyle.selfStyle.border.type == 'solid'?'#8c62ff':'#fff',color: selectdItem.preStyle.selfStyle.border.type == 'solid'?'#fff':'#000',border: selectdItem.preStyle.selfStyle.border.type == 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">实线</span>
				</div>
				<div @click="selectdItem.preStyle.selfStyle.border.type = 'dashed'"
					:style="{backgroundColor:selectdItem.preStyle.selfStyle.border.type == 'dashed'?'#8c62ff':'#fff',color:selectdItem.preStyle.selfStyle.border.type == 'dashed'?'#fff':'#000',border:selectdItem.preStyle.selfStyle.border.type == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">虚线</span>
				</div>
			</div>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">边框颜色</div>
			<el-color-picker size="mini" style="height: 34px;width: 34px;"
				v-model="selectdItem.preStyle.selfStyle.border.color"></el-color-picker>
			<el-input size="mini" style="height: 34px;width: 82px;" disabled
				:value="selectdItem.preStyle.selfStyle.border.color"></el-input>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div v-if="selectdItem.preStyle.selfStyle.border.borderSize" style="margin-top: 10px;">
				<div>线条大小</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.preStyle.selfStyle.border.borderSize[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.preStyle.selfStyle.border.borderSize[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.preStyle.selfStyle.border.borderSize[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.preStyle.selfStyle.border.borderSize[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="borderContainerSizeAll = !borderContainerSizeAll"
							:style="{color:borderContainerSizeAll?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div style="margin-top: 10px;" v-if="selectdItem.preStyle.selfStyle.border.borderRadius">
				<div>边框圆角</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px 0px 6px 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.preStyle.selfStyle.border.borderRadius[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.preStyle.selfStyle.border.borderRadius[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.preStyle.selfStyle.border.borderRadius[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top:2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.preStyle.selfStyle.border.borderRadius[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="borderContainerRadiusAll = !borderContainerRadiusAll"
							:style="{color:borderContainerRadiusAll?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
		<!-- <div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div v-if="selectdItem.preStyle.selfStyle.border.borderSize" style="margin-top: 10px;">
				<div>内边距</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSet" v-model="selectdItem.preStyle.selfStyle.padding[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSet" v-model="selectdItem.preStyle.selfStyle.padding[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSet" v-model="selectdItem.preStyle.selfStyle.padding[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSet" v-model="selectdItem.preStyle.selfStyle.padding[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="paddingAll = !paddingAll" :style="{color:paddingAll?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div> -->


		<div v-if="selectdItem.preStyle.selfStyle.margin" style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div style="margin-top: 10px;">
				<div>外边距</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="marginSet" v-model="selectdItem.preStyle.selfStyle.margin[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="marginSet" v-model="selectdItem.preStyle.selfStyle.margin[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="marginSet" v-model="selectdItem.preStyle.selfStyle.margin[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="marginSet" v-model="selectdItem.preStyle.selfStyle.margin[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="marginAll = !marginAll" :style="{color:marginAll?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div style="display: flex;justify-content: center;cursor: pointer;margin-top: 15px;">
				<div style="background-color: #F6F7F9;display: flex;flex-direction: column;width: 198px;">
					<div style="display: flex;justify-content: space-between">
						<div style="margin: 6px;">
							容器背景
						</div>
						<div v-if="selectdItem.preStyle.selfStyle.bg.bgtype"
							style="display: flex;align-items: center;margin-left:0px;">
							<div @click="selectdItem.preStyle.selfStyle.bg.bgtype = 'color'"
								:style="{backgroundColor:selectdItem.preStyle.selfStyle.bg.bgtype == 'color'?'#8c62ff':'#fff',color:selectdItem.preStyle.selfStyle.bg.bgtype == 'color'?'#fff':'#000',border:selectdItem.preStyle.selfStyle.bg.bgtype == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">纯色</span>
							</div>
							<div @click="selectdItem.preStyle.selfStyle.bg.bgtype = 'gradient'"
								:style="{backgroundColor:selectdItem.preStyle.selfStyle.bg.bgtype == 'gradient'?'#8c62ff':'#fff',color:selectdItem.preStyle.selfStyle.bg.bgtype == 'gradient'?'#fff':'#000',border:selectdItem.preStyle.selfStyle.bg.bgtype == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">渐变</span>
							</div>
							<div @click="selectdItem.preStyle.selfStyle.bg.bgtype = 'img'"
								:style="{backgroundColor:selectdItem.preStyle.selfStyle.bg.bgtype == 'img'?'#8c62ff':'#fff',color:selectdItem.preStyle.selfStyle.bg.bgtype == 'img'?'#fff':'#000',border:selectdItem.preStyle.selfStyle.bg.bgtype == 'img'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">图片</span>
							</div>
						</div>
					</div>
					<div v-if="selectdItem.preStyle.selfStyle.bg.bgtype == 'img'"
						style="display: flex;justify-content: center;margin-top: 10px;width: 235px;font-size: 12px;">
						<div
							style="display: flex;align-items: center;background-color: #F6F7F9;height: 38px;width: 210px;justify-content: space-around;">
							<div style="font-size: 12px;">
								背景图片
							</div>
							<div @click="dialogVisible = true"
								style="height: 30px;width: 30px;background-color: #fff;display: flex;align-items: center;justify-content: center;">
								<el-image :src="selectdItem.preStyle.selfStyle.bg.img" style="cursor: pointer;">
									<div slot="error" class="image-slot">
										<i style="font-size: 16px;" class="el-icon-plus"></i>
									</div>
								</el-image>
							</div>
							<el-select size="mini" style="width: 82px;" v-model="selectdItem.preStyle.selfStyle.bg.type"
								filterable allow-create default-first-option placeholder="渲染方式">
								<el-option label="重复" value="repeat">
								</el-option>
								<el-option label="x轴重复" value="repeat-x">
								</el-option>
								<el-option label="y轴重复" value="repeat-y">
								</el-option>
								<el-option label="平铺" value="">
								</el-option>
								<el-option label="不平铺" value="no-repeat">
								</el-option>
							</el-select>
						</div>
					</div>

					<div v-if="selectdItem.preStyle.selfStyle.bg.bgtype == 'img'"
						style="display: flex;justify-content: center;">
						<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
							<div style="width: 40px;">
								宽度:
							</div>
							<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
								:styleObj="{width: '100px',height: '30px'}" :step="1" :min="1" :max="10000000000"
								:value="selectdItem.preStyle.selfStyle.bg.bgImgWidth"
								@change="(e)=>{selectdItem.preStyle.selfStyle.bg.bgImgWidth = e}"></wm-input-number>
						</div>
					</div>
					<div v-if="selectdItem.preStyle.selfStyle.bg.bgtype == 'img'"
						style="display: flex;justify-content: center;">
						<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
							<div style="width: 40px;">
								高度:
							</div>
							<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
								:styleObj="{width: '100px',height: '30px'}" :step="1" :min="1" :max="10000000000"
								:value="selectdItem.preStyle.selfStyle.bg.bgImgHeigth"
								@change="(e)=>{selectdItem.preStyle.selfStyle.bg.bgImgHeigth = e}"></wm-input-number>
						</div>
					</div>

					<div v-if="selectdItem.preStyle.selfStyle.bg.bgtype == 'img'"
						style="display: flex;align-items: center;margin-left: 10px;margin-top: 10px;">
						<div>
							背景位置
						</div>

						<el-select @change="(e)=>{selectdItem.preStyle.selfStyle.bg.position = e}"
							style="margin-left: 10px;width: 120px;" v-model="selectdItem.preStyle.selfStyle.bg.position"
							filterable allow-create default-first-option placeholder="图片位置">
							<el-option label="左上方" value="top left">
							</el-option>
							<el-option label="上中间" value="top center">
							</el-option>
							<el-option label="右上方" value="top right">
							</el-option>
							<el-option label="左中方" value="center left">
							</el-option>
							<el-option label="居中" value="center center">
							</el-option>
							<el-option label="右中方" value="center right">
							</el-option>
							<el-option label="下左方" value="bottom left">
							</el-option>
							<el-option label="下居中" value="bottom center">
							</el-option>
							<el-option label="下右方" value="bottom right">
							</el-option>
						</el-select>
					</div>

					<div v-if="selectdItem.preStyle.selfStyle.bg.bgtype == 'gradient'"
						style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
						<div
							style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
							<div style="display: flex;flex-direction: column;">
								<div style="display: flex;align-items: center;">
								</div>
								<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
									placeholder="请输入内容" v-model="selectdItem.preStyle.selfStyle.bg.bgGradient">
								</el-input>
							</div>
							<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
								需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
									href="https://www.eggradients.com/">Gradient1</a> <a style="margin-left: 4px;"
									target="_blank" href="https://webgradients.com/">Gradient2</a>
							</div>
						</div>
					</div>
					<div v-if="selectdItem.preStyle.selfStyle.bg.bgtype && selectdItem.preStyle.selfStyle.bg.bgtype == 'color'"
						style="display: flex;justify-content: center;margin-top: 10px;width: 210px;margin-bottom: 20px;font-size: 12px;">
						<div
							style="display: flex;align-items: center;background-color: #F6F7F9;height: 34px;width: 210px;justify-content: space-around;">
							<div style="font-size: 12px;">
								背景纯色
							</div>
							<el-color-picker size="mini" @change="(e)=>{
								selectdItem.preStyle.selfStyle.bg.color = e
							}" style="height: 28px;width: 28px;margin-top: 4px;"
								v-model="selectdItem.preStyle.selfStyle.bg.color"></el-color-picker>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :modal="false" custom-class="select-imgs" title="文件管理器" :visible.sync="dialogVisibleImgs" width="80%"
			:before-close="()=>{dialogVisibleImgs = false}">
			<select-img style="height: 70vh" @confirmImg="confirmSelect" v-if="dialogVisibleImgs"></select-img>
		</el-dialog>

		<el-dialog :modal="false" custom-class="select-imgs" title="文件管理器" :visible.sync="dialogVisibleLevleImgs"
			width="80%" :before-close="()=>{dialogVisibleLevleImgs = false}">
			<select-img style="height: 70vh" @confirmImg="confirmLevelSelect"
				v-if="dialogVisibleLevleImgs"></select-img>
		</el-dialog>
	</div>
</template>

<script>
	import selectImg from '../components/selectImg.vue'
	import wmInputNumber from '../components/inputNumber.vue'
	import selectPage from '../cpm/selectPage.vue'
	import {
		throttle
	} from 'lodash';
	import setAnimate from '../cpm/setAnimate.vue'
	export default {
		components: {
			selectImg,
			wmInputNumber,
			selectPage,
			setAnimate
		},
		props: {
			equipment: {
				type: String,
				default: "pc"
			},
			all_setting: {
				type: Array,
				default: []
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			fontList: {
				type: Array,
				default: []
			},
		},
		computed: {
			fontFamilyName: function() {
				if (this.all_setting.length > 0) {
					return this.all_setting[0].tabList[1].config.setfontFamily.name
				} else {
					return ''
				}
			}
		},
		data() {
			return {
				levelOptions: [{
						label: "文字",
						value: "text"
					}, {
						label: "图片",
						value: "img"
					},
					{
						label: "视频",
						value: "video"
					},
					{
						label: "按钮",
						value: "btn"
					}
				],
				// 默认为"slide"（普通位移切换），还可设置为"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
				types: [{
						label: "默认",
						value: "slide"
					},
					{
						label: "淡入",
						value: "fade"
					},
					{
						label: "方块",
						value: "cube"
					},
					{
						label: "3d流",
						value: "coverflow"
					},
					{
						label: "3d翻转",
						value: "flip"
					}
				],
				setIndex: 0,
				dialogVisibleImgs: false,
				dialogVisible: false,
				paddingAll: true,
				borderContainerRadiusAll: true,
				borderContainerSizeAll: true,
				lastExecTime: 0,
				throttleTimer: null,
				marginAll: true,
				dialogVisibleLevleImgs: false,
				levelSelceItem: null

			}
		},
		mounted() {
			if (!this.selectdItem.preStyle.selfStyle.phoneHeight) {
				this.$set(this.selectdItem.preStyle.selfStyle, 'phoneHeight', 100)
			}
			this.addSetPropertyName()
		},
		methods: {
			throttleInput(value) {
				const now = Date.now();
				const throttleDelay = 500; // 500毫秒

				// 清除之前设置的定时器
				clearTimeout(this.throttleTimer);

				// 如果距离上次执行时间超过了节流时间，立即执行
				if (now - this.lastExecTime >= throttleDelay) {
					this.handleActualInput(value);
					this.lastExecTime = now;
				} else {
					// 否则设置定时器，在节流时间结束后执行
					this.throttleTimer = setTimeout(() => {
						this.handleActualInput(value);
						this.lastExecTime = Date.now();
					}, throttleDelay - (now - this.lastExecTime));
				}
			},

			handleActualInput(value) {
				console.log('节流后的输入值:', value);
				// 这里执行实际的业务逻辑
			},

			addLevel(item) {
				item.levelList.push({
					animateConfig: [{

						type: "topBto", // topBto 从上下 从左右 leftRight rotate opacity scale
						value: 0,
						rotateType: "1", // 度数 圈速

						// 可见时播放
						lookedPlay: true,
						// 动效类型
						ease: "linear",
						// 	// 循环播放
						loop: false,
						// 	// 循环延迟
						// loopDelay: 0,
						// 	// 播放时间 默认2s
						duration: 2,
						// 	// 延迟多久播放
						delay: 0,
						// 	// 播放速度
						playbackRate: 1,

						y: [],
						// x
						x: [],
						//旋转
						rotate: [],
						// 透明度
						opacity: [],
						// 缩放
						scale: [],
					}],
					loop: false,
					icon: "",
					width: 100,
					height: 100,
					phoneWidth: 100,
					phoneHeight: 100,
					mode: "cover", // contain
					type: "text",
					position: "center",
					titClickColor: "",
					btnClickColor: "",
					firstImg: "", // 视频封面
					tit: "",
					titSize: 14,
					titFamily: this.fontFamilyName,
					titColor: "#000",
					titHoverColor: "",
					padding: [0, 0, 0, 0],
					margin: [0, 0, 0, 0],
					btnHoverColor: "",
					btnBorderHoverColor: "",
					btnBorderClickColor: "",
					bg: {
						position: "top left",
						bgtype: "color", // color gradient img
						bgGradient: "",
						bgImgWidth: 0,
						bgImgHeigth: 0,
						img: "",
						type: "no-repeat",
						color: "",
					},

					bgHover: {
						position: "top left",
						bgtype: "color", // color gradient img
						bgGradient: "",
						bgImgWidth: 0,
						bgImgHeigth: 0,
						img: "",
						type: "no-repeat",
						color: "",
					},

					bgBorder: {
						borderRadius: [0, 0, 0, 0],
						borderSize: [0, 0, 0, 0],
						radius: 0,
						type: "solid",
						px: 0,
						color: "#fff"
					},

					border: {
						borderRadius: [0, 0, 0, 0],
						borderSize: [0, 0, 0, 0],
						radius: 0,
						type: "",
						px: 0,
						color: "#fff"
					},
					link: {},
					url: "", // 素材库里面选择
					control: false, // 是否需要播放控制器
					isAuto: true, // 是否自动播放视频
					paddingLeveAll: true,
					marginLevelAll: true,

					borderContainerSizeAll: true,
					borderContainerRadiusAll: true,
					zIndex: 1,
					marginAll: true,
					data: {}
				})
			},
			addSetPropertyName() {
				this.selectdItem.compontChildren[0].data.list.forEach(item => {
					if (!item.levelList) {
						this.$set(item, 'levelList', [])
					} else {
						item.levelList.forEach(levelItem => {
							if (!levelItem.animateConfig) {
								this.$set(levelItem, 'animateConfig', [])
							}
						})
					}
				})

				if (!this.selectdItem.preStyle.selfStyle.margin) {
					this.$set(this.selectdItem.preStyle.selfStyle, 'margin', [0, 0, 0, 0])
				}

				console.log('selectdItemselectdItem', this.selectdItem)
			},


			getFileType(filename) {
				if (!filename) {
					return
				}
				console.log('filenamefilename', filename)
				// 获取文件扩展名（转换为小写以便比较）
				const ext = filename.split('.').pop().toLowerCase();

				// 图片类型扩展名
				const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff'];

				// 视频类型扩展名
				const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv', 'webm', 'mpeg'];

				if (imageExtensions.includes(ext)) {
					return 'image';
				} else if (videoExtensions.includes(ext)) {
					return 'video';
				} else {
					return 'unknown';
				}
			},
			deleteItem(index) {
				this.selectdItem.compontChildren[0].data.list.splice(index, 1)
				let ik = -1
				this.selectdItem.compontChildren[0].data.list.forEach(e => {
					if (e.url == '') {
						ik = 1
					}
				})
				if (ik == -1) {
					this.selectdItem.compontChildren[0].data.list.push({
						url: ""
					})
				}
			},
			confirmLevelSelect(e) {
				this.levelSelceItem.url = e.url
				this.levelSelceItem.data = e
				this.dialogVisibleLevleImgs = false
			},
			confirmSelect(e) {
				console.log('e', e)

				if (this.selectdItem.compontChildren[0].data.list[this.setIndex].type == 'video') {
					console.log('e.url.substring(e.url.lastIndexOf("."))',e.url.substring(e.url.lastIndexOf(".")))
					if(e.url.substring(e.url.lastIndexOf(".")) != '.mp4'){
						this.$message.error('文件格式不是 mp4 格式')
						return 
					}
				}
				let isReplace = false
				if (this.selectdItem.compontChildren[0].data.list[this.setIndex].url != '') {
					isReplace = true
				}
				this.selectdItem.compontChildren[0].data.list[this.setIndex].url = e.url
				this.selectdItem.compontChildren[0].data.list[this.setIndex].data = e
				if (!isReplace) {
					this.selectdItem.compontChildren[0].data.list.push({
						type: "img", // video
						url: "", // 素材库里面选择
						control: false, // 是否需要播放控制器
						isAuto: false, // 是否自动播放视频
						loop: false,
						firstImg: "", // 视频封面
						link: {},
						data: {},
						levelList: []
					})
				}

				this.dialogVisibleImgs = false

			},

			paddingLevelSet(e, levelItem) {
				if (levelItem.paddingLeveAll) {
					levelItem.padding = []
					levelItem.padding.push(e.target.value)
					levelItem.padding.push(e.target.value)
					levelItem.padding.push(e.target.value)
					levelItem.padding.push(e.target.value)
				}
			},
			marginLevelSet(e, levelItem) {
				console.log('levelItem', levelItem)
				if (levelItem.marginLevelAll) {
					levelItem.margin = []
					levelItem.margin.push(e.target.value)
					levelItem.margin.push(e.target.value)
					levelItem.margin.push(e.target.value)
					levelItem.margin.push(e.target.value)
				}
			},
			marginSet(e) {
				console.log('event.target.value', event.target.value)
				if (this.marginAll) {
					this.selectdItem.preStyle.selfStyle.margin = []
					this.selectdItem.preStyle.selfStyle.margin.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.margin.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.margin.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.margin.push(e.target.value)
				}
			},

			paddingSet(e) {
				console.log('event.target.value', event.target.value)
				if (this.paddingAll) {
					this.selectdItem.preStyle.selfStyle.padding = []
					this.selectdItem.preStyle.selfStyle.padding.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.padding.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.padding.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.padding.push(e.target.value)
				}
			},

			levelChangeContainerSize(e, levelItem) {
				if (levelItem.borderContainerSizeAll) {
					levelItem.border.borderSize = []
					levelItem.border.borderSize.push(e.target.value)
					levelItem.border.borderSize.push(e.target.value)
					levelItem.border.borderSize.push(e.target.value)
					levelItem.border.borderSize.push(e.target.value)
				}
			},
			levelChangeContainerBorderRadius(e, levelItem) {
				if (levelItem.borderContainerRadiusAll) {
					levelItem.border.borderRadius = []
					levelItem.border.borderRadius.push(e.target.value)
					levelItem.border.borderRadius.push(e.target.value)
					levelItem.border.borderRadius.push(e.target.value)
					levelItem.border.borderRadius.push(e.target.value)
				}
			},

			changeContainerBorderRadius(e) {
				if (this.borderContainerRadiusAll) {
					this.selectdItem.preStyle.selfStyle.border.borderRadius = []
					this.selectdItem.preStyle.selfStyle.border.borderRadius.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.border.borderRadius.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.border.borderRadius.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.border.borderRadius.push(e.target.value)
				}
			},
			changeContainerSize(e) {
				if (this.borderContainerSizeAll) {
					this.selectdItem.preStyle.selfStyle.border.borderSize = []
					this.selectdItem.preStyle.selfStyle.border.borderSize.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.border.borderSize.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.border.borderSize.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.border.borderSize.push(e.target.value)
				}
			},
		}

	}
</script>

<style scoped lang="scss">
	.item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 10px;
	}

	input:focus {
		outline: none;
		border: 1px solid #242754;
		border-radius: 3px;
	}

	input {
		outline: none;
		border: 1px solid #c1c1c1;
		border-radius: 5px;

	}
</style>